import type { Router } from '~/server/trpc/routers'
import superjson from 'superjson'
import { createTRPCNuxtClient, httpBatchLink } from 'trpc-nuxt/client'

export default defineNuxtPlugin(() => {
  /**
   * createTRPCNuxtClient adds a `useQuery` composable
   * built on top of `useAsyncData`.
   */
  const trpc = createTRPCNuxtClient<Router>({
    transformer: superjson,
    links: [httpBatchLink()],
  })

  return {
    provide: {
      trpc,
    },
  }
})
